import { tns, TinySliderInstance } from 'tiny-slider';

export default class GallerySlider {
    static init(): void {
        const sliders: NodeListOf<HTMLElement> = document.querySelectorAll('.js-gallery-slider');

        sliders.forEach((slider) => {
            const instance = tns({
                container: slider,
                fixedWidth: 297,
                gutter: 30,
                edgePadding: 0,
                controls: false,
                nav: false,
                loop: false,
                mouseDrag: true,
                swipeAngle: false,
            });

            this.bindWheel(slider, instance);
        });
    }

    static bindWheel(slider: HTMLElement, instance: TinySliderInstance): void {
        const outer = (slider.closest('.tns-outer') ?? slider) as HTMLElement;

        let isThrottled = false;

        outer.addEventListener(
            'wheel',
            (event: WheelEvent) => {
                if (Math.abs(event.deltaX) <= Math.abs(event.deltaY)) {
                    return;
                }

                event.preventDefault();

                if (isThrottled) {
                    return;
                }

                isThrottled = true;
                instance.goTo(event.deltaX > 0 ? 'next' : 'prev');

                window.setTimeout(() => {
                    isThrottled = false;
                }, 400);
            },
            { passive: false },
        );
    }
}
